import { Base } from "@studiometa/js-toolkit";
class Editors extends Base {
  /**
   * Config.
   */
  static config = {
    name: "Editors"
  };
  hide() {
    this.$write(() => {
      this.$el.classList.add("hidden");
    });
  }
  show() {
    this.$write(() => {
      this.$el.classList.remove("hidden");
    });
  }
}
export {
  Editors as default
};
//# sourceMappingURL=Editors.js.map
